/**
 * Payment Service - Flow.cl Integration
 * 
 * Handles checkout session creation for subscription upgrades.
 */
import api from '../api/axios';

/**
 * Create a checkout session for a specific plan
 * @param {number} planId - The ID of the plan to subscribe to
 * @returns {Promise<{checkout_url: string, plan_name: string}>}
 */
export const createCheckoutSession = async (planId) => {
  try {
    const response = await api.post('/cuentas/flow/iniciar-registro/', {
      plan_id: planId
    });
    
    return response.data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    
    // Re-throw with user-friendly message
    const message = error.response?.data?.error || 'Error al iniciar el registro de pago';
    throw new Error(message);
  }
};

/**
 * Redirect user to Flow checkout
 * @param {number} planId - The ID of the plan to subscribe to
 */
export const redirectToCheckout = async (planId) => {
  const { checkout_url } = await createCheckoutSession(planId);
  
  if (checkout_url) {
    window.location.href = checkout_url;
  } else {
    throw new Error('No se recibió URL de checkout');
  }
};

/**
 * Cancel the current subscription
 * @returns {Promise<{message: string}>}
 */
export const cancelSubscription = async () => {
  try {
    const response = await api.post('/cuentas/flow/gestionar/', {
      action: 'cancel'
    });
    return response.data;
  } catch (error) {
    console.error('Error canceling subscription:', error);
    const message = error.response?.data?.error || 'Error al cancelar la suscripción';
    throw new Error(message);
  }
};

/**
 * Fetch available subscription plans
 */
export const fetchPlanes = async () => {
  try {
    const response = await api.get('/cuentas/planes/');
    return response.data;
  } catch (error) {
    console.error('Error fetching planes:', error);
    throw new Error('Error al cargar la lista de planes');
  }
};

const paymentService = {
  createCheckoutSession,
  redirectToCheckout,
  cancelSubscription,
  fetchPlanes
};

export default paymentService;
